import React from 'react'
import { Link } from 'react-router-dom'
import { clickGTM } from '../../services/Gtm/gtmInteractions'
import axios from 'axios'

const Header = () => {
  const { handleClick } = clickGTM()
  const isNewCampaignFreeDays = process.env.REACT_APP_IS_NEW_CAMPAIGN_FREE_DAYS === 'true'

  const currentDays = process.env.REACT_APP_CURRENT_NUMBER_FREE_DAYS
  const futureDays = process.env.REACT_APP_FUTURE_NUMBER_FREE_DAYS
  console.log(
    'isNewCampaignFreeDays:',
    JSON.stringify({ isNewCampaignFreeDays, currentDays, futureDays }, null, 2)
  )
  return (
    <div className="wellcome_area clearfix" id="home">
      <div className="container h-100">
        <div className="row h-100 align-items-center">
          <div className="col-12 col-md-7 col-lg-6 header-content">
            <div className="wellcome-heading">
              <h2>
                <span className="text-white text-uppercase">
                  ¡Empieza a vivir momentos Wong Prime!
                </span>
              </h2>
              <p>
                <strong className="text-white  d-block mb-3">
                  Tus compras de supermercado con{' '}
                  <span>
                    envíos gratis e ilimitados<sup>*</sup>, doble acumulación de puntos bonus,{' '}
                  </span>{' '}
                  descuentos en combustible en Primax y mucho más.
                </strong>
              </p>
              <strong className="d-block text-white">
                Prueba desde hoy{' '}
                {isNewCampaignFreeDays ? (
                  <>
                    <del className="strike-with-padding">{currentDays}</del> {futureDays}
                  </>
                ) : (
                  currentDays
                )}{' '}
                días{isNewCampaignFreeDays && '**'} ¡Sin costo!
              </strong>
              {process.env.REACT_APP_IS_NEW_CAMPAIGN_FREE_DAYS === 'true' && (
                <p className="text-white">
                  **Campaña promocional válida del {process.env.REACT_APP_VALIDITY_CAMPAIGN}{' '}
                  inclusive.
                </p>
              )}
            </div>
            <div className="get-start-area">
              <Link
                className="submit"
                to="/auth/register"
                onClick={(e) => {
                  handleClick(e, 'Home - Body')
                }}>
                {' '}
                <i className="fa fa-bookmark"></i> Prueba{' '}
                {isNewCampaignFreeDays ? (
                  <>
                    <del className="strike-with-padding">{currentDays}</del> {futureDays}
                  </>
                ) : (
                  currentDays
                )}{' '}
                días{isNewCampaignFreeDays && '**'} gratis{' '}
              </Link>
              <p>
                <strong className="d-block">* Válido para compras desde S/ 79.90</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header